import {
  FETCH_ESTIMATE,
  FETCH_ESTIMATE_SUCCESS,
  FETCH_ESTIMATE_FAILED,
  CLEAR_ESTIMATE
} from "../store/types";
import Polyline from '@mapbox/polyline';
import { firebase } from '../config/configureFirebase';
import { FareCalculator } from '../other/FareCalculator';
import { onValue } from "firebase/database";

export const getEstimate = (bookingData) => async (dispatch) => {
  const   {
      settingsRef
  } = firebase;

  dispatch({
    type: FETCH_ESTIMATE,
    payload: bookingData,
  });
          

  let res = bookingData.routeDetails;

  if(res){
    // Este thunk se despacha sin .catch: si onValue lanzara (p. ej. ref no
    // disponible), el rechazo llegaba al manejador global como "Operación no
    // completada". Fallamos por contrato para que la UI muestre su propio aviso.
    try {
      onValue(settingsRef, settingdata => {
      try {
        // La decodificación del polyline va DENTRO del try: con rutas degeneradas
        // (p. ej. origen = destino) el polyline puede venir vacío/indefinido y
        // lanzaría una excepción que dejaba la estimación colgada (spinner infinito).
        let points = res.polylinePoints ? Polyline.decode(res.polylinePoints) : [];
        let waypoints = points.map((point) => {
            return {
                latitude: point[0],
                longitude: point[1]
            }
        });
        let settings = settingdata.val();

        // Saneamos los valores numéricos: con rutas degeneradas (origen = destino)
        // Google puede devolver distance_in_km/time_in_secs nulos o indefinidos,
        // produciendo NaN. Firebase RECHAZA escrituras con NaN ("value argument
        // contains NaN"), así que normalizamos todo a números finitos (0 por defecto).
        const toNum = (v) => {
          const n = parseFloat(v);
          return Number.isFinite(n) ? parseFloat(n.toFixed(settings.decimal)) : 0;
        };
        const rawKm = parseFloat(res.distance_in_km);
        const km = Number.isFinite(rawKm) ? rawKm : 0;
        const rawSecs = parseFloat(res.time_in_secs);
        const timeSecs = Number.isFinite(rawSecs) ? rawSecs : 0;
        let distance = settings.convert_to_mile ? (km / 1.609344) : km;

       let {totalCost, grandTotal, convenience_fees} = FareCalculator(distance, timeSecs, bookingData.carDetails, bookingData.instructionData, settings.decimal);

        dispatch({
          type: FETCH_ESTIMATE_SUCCESS,
          payload: {
            pickup:bookingData.pickup,
            drop:bookingData.drop,
            carDetails:bookingData.carDetails,
            instructionData: bookingData.instructionData,
            estimateDistance: toNum(distance),
            fareCost: toNum(totalCost),
            estimateFare: toNum(grandTotal),
            estimateTime: timeSecs,
            convenience_fees: toNum(convenience_fees),
            waypoints: waypoints
          },
        });
      } catch (error) {
        dispatch({
          type: FETCH_ESTIMATE_FAILED,
          payload: (error && (error.message || error.toString())) || "Estimate error",
        });
      }
    }, {onlyOnce:true});
    } catch (error) {
      dispatch({
        type: FETCH_ESTIMATE_FAILED,
        payload: (error && (error.message || error.toString())) || "Estimate error",
      });
    }
  }else{
    dispatch({
      type: FETCH_ESTIMATE_FAILED,
      payload: "No Route Found",
    });
  }

}

export const clearEstimate = () => (dispatch) => {
    dispatch({
        type: CLEAR_ESTIMATE,
        payload: null,
    });    
}
